import styled, {css} from "styled-components";

const cssBase = css`
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
    align-self: stretch;
`;

export const Header = styled.p`
    ${cssBase};
    color: ${({theme}) => theme.colors.gray4};
    font-family: ${({theme}) => theme.fonts.lexendDeca};
    font-size: 16px;
    letter-spacing: -0.16px;
`;

export const Body = styled.p`
    ${cssBase};
    color: ${({theme}) => theme.colors.gray3};
    font-family: ${({theme}) => theme.fonts.inter};
    font-size: 14px;
    letter-spacing: -0.092px;
    font-variant-numeric: lining-nums tabular-nums;
`;

export const ContactSupportLink = styled.a`
    ${cssBase};
    color: ${({theme}) => theme.colors.gray3};
    font-family: ${({theme}) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.092px;
    font-variant-numeric: lining-nums tabular-nums;
    text-decoration: underline;
`;